import React, { useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";
import Preloader from "../Component/Preloader/Preloader";
import { useAuth } from "../Store/AuthContext";
import { Helmet } from "react-helmet";
// import { ProjectCatFetchData, ServiceFetchData } from "../APIS/FetchAPIs";

export default function Header() {
  const { webSetting } = useAuth();
  // const [ServiceData] = ServiceFetchData(RendomTokenfetch);
  // const [ProjectCatData] = ProjectCatFetchData(RendomTokenfetch);

  const navigaṭe = useNavigate();

  const NotMathURL = /[’/`~!#*$@%+=.,^&(){}[\]|;:”<>?\\]/g;
  const patthnameURL = useLocation();
  useEffect(() => {
    if (NotMathURL.test(patthnameURL.search)) {
      navigaṭe("/page-not-found");
      // window.location.reload();
    }
  });

  return (
    <>
      <Preloader />

      {/* <DisclaimerPopup /> */}

      <Helmet>
        <link rel="icon" type="image/x-icon" href={webSetting.favicon} />
      </Helmet>

      <div className="fix-area">
        <div className="offcanvas__info">
          <div className="offcanvas__wrapper">
            <div className="offcanvas__content">
              <div className="offcanvas__top mb-3 d-flex justify-content-between align-items-center">
                <div className="offcanvas__logo">
                  <Link to="/" aria-label="WebSite Logo">
                    {webSetting.website_logo !== "" ? (
                      <img src={webSetting.website_logo} alt="" />
                    ) : (
                      ""
                    )}
                  </Link>
                </div>
                <div className="offcanvas__close">
                  <button>
                    <i className="fas fa-times"></i>
                  </button>
                </div>
              </div>
              <p className="text d-none d-xl-block">
                Nullam dignissim, ante scelerisque the is euismod fermentum odio
                sem semper the is erat, a feugiat leo urna eget eros. Duis
                Aenean a imperdiet risus.
              </p>
              <div className="mobile-menu fix mb-3"></div>
              <div className="offcanvas__contact">
                <h4>Contact Info</h4>
                <ul>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon">
                      <i className="fal fa-map-marker-alt"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                      <Link target="_blank" to="/">
                        {webSetting?.address || ""}
                      </Link>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="fal fa-envelope"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                      <Link
                        to={`mailto:${
                          webSetting?.email || " info@bhadorva.com"
                        }`}
                        aria-label="Client Email"
                      >
                        <span className="mailto:info@example.com">
                          {webSetting?.email || " info@bhadorva.com"}
                        </span>
                      </Link>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="fal fa-clock"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                      <Link target="_blank" to="/">
                        Mod-friday, 09am -05pm
                      </Link>
                    </div>
                  </li>
                  <li className="d-flex align-items-center">
                    <div className="offcanvas__contact-icon mr-15">
                      <i className="far fa-phone"></i>
                    </div>
                    <div className="offcanvas__contact-text">
                      <Link
                        to={`tel:+91${webSetting?.number || " +918308365556"}`}
                        aria-label="Client Contact Number"
                      >
                        +91 {webSetting?.number || " +91 8308365556"}
                      </Link>
                    </div>
                  </li>
                </ul>
                <div className="header-button mt-4"></div>
                <Link to="/our-project" className="theme-btn">
                  Our Properties <i className="flaticon-home"></i>
                </Link>
                <div className="social-icon d-flex align-items-center">
                  <Link
                    to={webSetting?.facebook || ""}
                    target="blank"
                    rel="noreferrer"
                    aria-label="Facebook Account"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link
                    to={webSetting?.instagram || ""}
                    target="blank"
                    className="mx-2"
                    aria-label="Instagram Account"
                  >
                    <i className="fab fa-instagram"></i>
                  </Link>
                  <Link
                    to={webSetting?.youtube || ""}
                    target="blank"
                    aria-label="Youtube Account"
                  >
                    <i className="fab fa-youtube"></i>
                  </Link>
                  <Link
                    to={webSetting?.linkedIn || ""}
                    target="blank"
                    className="ms-2"
                    aria-label="Linkedin Account"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="offcanvas__overlay"></div>

      <div className="topbar">
        <div className="container-fluid">
          <div className="row">
            <div
              className="col-lg-6 col-md-6 col-sm-12 col-xs-12"
              id="topbarEmil"
            >
              <div className="topbarEmil">
                <div className="social-icon">
                  <Link
                    to={webSetting?.facebook || ""}
                    target="blank"
                    rel="noreferrer"
                    aria-label="Facebook Account"
                  >
                    <i className="fab fa-facebook-f"></i>
                  </Link>
                  <Link
                    to={webSetting?.instagram || ""}
                    target="blank"
                    className="mx-2"
                    aria-label="Instagram Account"
                  >
                    <i className="fab fa-instagram"></i>
                  </Link>
                  <Link
                    to={webSetting?.youtube || ""}
                    target="blank"
                    aria-label="Youtube Account"
                  >
                    <i className="fab fa-youtube"></i>
                  </Link>
                  <Link
                    to={webSetting?.linkedIn || ""}
                    target="blank"
                    className="ms-2"
                    aria-label="Linkedin Account"
                  >
                    <i className="fab fa-linkedin-in"></i>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-lg-6 col-md-6 col-sm-12 col-xs-12"
              id="topbarNumber"
            >
              <div className="topbarNumber">
                <Link
                  to={`tel:+91${webSetting?.number || " +918308365556"}`}
                  aria-label="Client Contact Number"
                >
                  <i className="fa-solid fa-phone-xmark"></i>
                  +91 {webSetting?.number || " +91 8308365556"}
                </Link>
                <Link
                  to={`mailto:${webSetting?.email || " info@bhadorva.com"}`}
                  className="ms-3"
                  aria-label="Client Email"
                >
                  <i className="fa-solid fa-envelopes"></i>
                  {webSetting?.email || " info@bhadorva.com"}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <header id="header-sticky" className="header-1 header-2 style-3">
        <div className="container-fluid">
          <div className="mega-menu-wrapper">
            <div className="header-main">
              <div className="logo">
                <Link to="/" className="header-logo-3">
                  {webSetting.website_logo !== "" ? (
                    <img src={webSetting.website_logo} alt="" />
                  ) : (
                    <img src="../assets/img/logo/logo.png" alt="logo-img" />
                  )}
                </Link>
              </div>
              <div className="mean__menu-wrapper">
                <div className="main-menu">
                  <nav id="mobile-menu">
                    <ul>
                      <li className="active">
                        <NavLink to="/">Home</NavLink>
                      </li>
                      <li className="has-dropdown">
                        <Link to={`#`}>
                          About <i className="fa-solid fa-angle-down ms-1"></i>
                        </Link>
                        <ul className="submenu">
                          <li>
                            <NavLink to={`/about-us`}>About Bhadorva</NavLink>
                          </li>
                          <li>
                            <NavLink to={`/founders-desk`}>
                              Founders Desk
                            </NavLink>
                          </li>
                        </ul>
                      </li>
                      <li className="has-dropdown">
                        <Link to={`#`}>
                          Services{" "}
                          <i className="fa-solid fa-angle-down ms-1"></i>
                        </Link>
                        <ul className="submenu">
                          {/* {ServiceData.length > 0
                            ? ServiceData.slice(0, 5).map((service, index) => (
                                <li key={index}>
                                  <NavLink to={`/service/${service.slug}`}>
                                    {service.title}
                                  </NavLink>
                                </li>
                              ))
                            : ""} */}
                          <li>
                            <NavLink to={`/service/construction-projects`}>
                              Construction Projects
                            </NavLink>
                          </li>
                          <li>
                            <NavLink to={`/service/villa-bungalow-development`}>
                              Villa & Bungalow Development
                            </NavLink>
                          </li>
                          <li>
                            <NavLink to={`/service/plotting-land-development`}>
                              Plotting & Land Development
                            </NavLink>
                          </li>
                          <li>
                            <NavLink to={`/service/purchasing-reselling`}>
                              Purchasing & Reselling
                            </NavLink>
                          </li>
                          <li>
                            <NavLink to={`/service/redevelopment-projects`}>
                              Redevelopment Projects
                            </NavLink>
                          </li>
                        </ul>
                      </li>

                      <li className="has-dropdown">
                        <Link to={`#`}>
                          projects{" "}
                          <i className="fa-solid fa-angle-down ms-1"></i>
                        </Link>
                        <ul className="submenu">
                          {/* {ProjectCatData.length > 0
                            ? ProjectCatData.map((catval, index) => (
                                <li key={index}>
                                  <NavLink to={`/${catval.slug}`}>
                                    {catval.title}
                                  </NavLink>
                                </li>
                              ))
                            : ""} */}
                          <li>
                            <NavLink to={`/plots`}>Plots</NavLink>
                          </li>
                          <li>
                            <NavLink to={`/residentials`}>Residentials</NavLink>
                          </li>
                        </ul>
                      </li>
                      <li className="has-dropdown">
                        <Link to={`#`}>
                          Media <i className="fa-solid fa-angle-down ms-1"></i>
                        </Link>
                        <ul className="submenu">
                          <li>
                            <NavLink to={`/media-coverage`}>
                              Media Coverage
                            </NavLink>
                          </li>
                          <li>
                            <NavLink to={`/newsletter`}>Newsletter</NavLink>
                          </li>
                          <li>
                            <NavLink to={`/blogs`}>Blogs</NavLink>
                          </li>
                        </ul>
                      </li>
                      {/* <li>
                        <NavLink to="/careers">Careers</NavLink>
                      </li> */}
                      <li>
                        <NavLink to="/nri-corner">NRI Corner</NavLink>
                      </li>
                      <li>
                        <NavLink to="/contact">Contact</NavLink>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div className="header-right d-flex justify-content-end align-items-center">
                {/* <Link to="/" className="main-header__search search-toggler">
                  <i className="fa-regular fa-magnifying-glass"></i>
                </Link>
                <Link to="/contact" className="theme-btn">
                  Contact <i className="fa fa-phone" aria-hidden="true"></i>
                </Link> */}
                <div className="header__hamburger d-xl-none my-auto">
                  <div className="sidebar__toggle">
                    <div className="header-bar">
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}
